module.exports = __webpack_public_path__ + "img/Nuts.da885d32.svg";